import { GlobalStatus, PackingStatus, PalletType, TransactionType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { StockStatus } from "../../stock/dto/stock-status.enum";
import { Shifts } from "../shifts.enum";

export class StockInDto {
  @ApiProperty()
  plantId: number;
  @ApiProperty()
  saleOrderId: number;
  @ApiProperty()
  saleOrderItemId: number;
  @ApiProperty()
  palletId: number;
  @ApiProperty()
  rackPostion: number;
  @ApiProperty()
  reportingCases: number;
  @ApiProperty()
  loosePouches: number;
  @ApiProperty()
  lotCode: string;
  @ApiProperty()
  createdUser: string;
  @ApiProperty()
  updatedUser: string;
  @ApiProperty({
    enum: TransactionType,
    default: TransactionType.palleting
  })
  transactionType: TransactionType;
  @ApiProperty({
    enum: PalletType,
    default: PalletType.new
  })
  palletType: PalletType;
  @ApiProperty({
    enum: PackingStatus,
    default: PackingStatus.NO
  })
  packingCompleted: PackingStatus;
  @ApiProperty()
  stockType: StockStatus;
  @ApiProperty()
  coldStorageId: number;
  @ApiProperty()
  reportingDate: Date;
  @ApiProperty()
  manualReported: boolean;
  @ApiProperty()
  traceCode: number;
  @ApiProperty({
    enum: Shifts,
    default: Shifts.general
  })
  shifts: Shifts;
  @ApiProperty()
  remarks?: string;
  @ApiProperty()
  cartonsStatus?:PackingStatus;
  @ApiProperty()
  pouchesStatus?:PackingStatus;
  @ApiProperty()
  variantId?:number;
  @ApiProperty()
  brandId?:number;
  @ApiProperty()
  packStyleId?:number;
  @ApiProperty()
  palletCode?:string;
  
}
